<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vs-sidebar--item" :class="[
    { 'vs-sidebar-item-active': activeLink },
    { 'disabled-item pointer-events-none': isDisabled },
  ]">
    <router-link v-if="to" exact :class="[{ 'router-link-active': activeLink }]" :to="to" :target="target"
      :id="'sidebar-item-' + (slug || icon || to).toString().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-_]/g, '')">
      <img width="20px" height="20px" style="margin-right: 14px" :src="imgIcon" v-if="isIMGIcon" />
      <vs-icon v-else-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
      <slot />
    </router-link>

    <a v-else :target="target" :href="href">
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
      <slot />
    </a>
  </div>
</template>

<script>
import { runTutorial } from '@/tutorial/guide.js';
export default {
  name: "v-nav-menu-item",
  props: {
    icon: { type: String, default: "" },
    iconSmall: { type: Boolean, default: false },
    iconPack: { type: String, default: "material-icons" },
    href: { type: [String, null], default: "#" },
    to: { type: [String, Object, null], default: null },
    slug: { type: String, default: null },
    index: { type: [String, Number], default: null },
    featherIcon: { type: Boolean, default: true },
    target: { type: String, default: "_self" },
    isDisabled: { type: Boolean, default: false },
  },
  computed: {
    activeLink() {
      return this.to == this.$route.path ||
        (this.$route.meta.parent == this.slug && this.to)
        ? true
        : false;
    },
    isIMGIcon() {
      return this.icon.includes("IMG") ? this.icon.replace("IMG-", "") : false;
    },
    imgIcon() {
      const isIMGIcon = this.isIMGIcon;
      return this.activeLink
        ? require(`@/assets/images/icons/${isIMGIcon}_bg_white.png`)
        : require(`@/assets/images/icons/${isIMGIcon}.png`);
    },
  },
  mounted() {
    // wait a tick for the dashboard itself…
    this.$nextTick(() => {
      // …and one more animation frame so the sidebar is ready too
      requestAnimationFrame(() => {
        runTutorial([
          {
            element: '#sidebar-item-home',
            intro: 'This is your Dashboard menu item.',
            key: 'sidebar-dashboard',
          },
          {
            element: '#sidebar-item-users',
            intro: 'You can view your users here.',
            key: 'sidebar-users',
          },
          {
            element: '#sidebar-item-vessels',
            intro: 'You can view your vessels here.',
            key: 'sidebar-vessels',
          },
          {
            element: '#sidebar-item-project',
            intro: 'You can view your projects here.',
            key: 'sidebar-project',
          },
          {
            element: '#sidebar-item-ai-analyst',
            intro: 'This is your AI Analyst feature.',
            key: 'sidebar-ai-analyst',
          },
        ]);
      });
    });
  },
};
</script>
